export default {"src":"/_next/static/media/order_icon.98a01bd0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};